"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountrySuggestionSchema = exports.CountrySchema = void 0;
const zod_1 = require("zod");
const base_1 = require("../base");
const enums_1 = require("../enums");
exports.CountrySchema = zod_1.z.object({
    name: base_1.ShortStringSchema,
    countryCode: zod_1.z.nativeEnum(base_1.Alpha3Countries),
    currencyCode: zod_1.z.nativeEnum(enums_1.Currency),
    suggestedLanguage: base_1.ShortStringSchema,
    suggestedTimeZone: zod_1.z.nativeEnum(enums_1.TimeZone),
    callingCode: base_1.ShortStringSchema,
    flag: zod_1.z.string().url(),
});
exports.CountrySuggestionSchema = exports.CountrySchema.extend({
    city: base_1.ShortStringSchema.optional(),
    stateOrRegion: base_1.ShortStringSchema.optional(),
    district: base_1.ShortStringSchema.optional(),
});
//# sourceMappingURL=index.js.map